"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _flagsInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/flags");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.bootstrap = void 0;

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));

var _AppFlags = require("./App/AppFlags");

var _csrf = require("./auth/csrf");

var _environment = require("./environment");

var _featureFlags = require("./feature-flags");

require("./i18n");

var _setDefaultProviders = require("./telemetry/setDefaultProviders");

var _treatmentService = require("./telemetry/treatmentService");

var bootstrap = function bootstrap() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;
  (0, _setDefaultProviders.setDefaultProviders)();
  (0, _AppFlags.registerAppFlags)();
  var bootRequirements = [];

  if (process.env.APP_ENABLE_FLIGHTING === 'true') {
    var flightingEndpoint = process.env.APP_FLIGHTING_ENDPOINT;
    var flightingEndpointApi = process.env.APP_FLIGHTING_ENDPOINT_API;

    if (!flightingEndpoint && flightingEndpointApi) {
      flightingEndpoint = (0, _environment.getApiServerUrl)(flightingEndpointApi);
    } else if (flightingEndpointApi !== undefined) {
      flightingEndpoint += flightingEndpointApi;
    }

    if (flightingEndpoint !== undefined) {
      _treatmentService.treatmentService.setEndpoint(flightingEndpoint);

      _treatmentService.treatmentService.getFlags().catch(function () {
        return undefined;
      });
    }
  }

  _flagsInstanceProperty(_featureFlags).addFlagService(_treatmentService.treatmentService);

  _csrf.csrf.init();

  if (process.env.APP_ENABLE_CLICKTALE === 'true') {
    var isClickTaleEnabled;

    if (process.env.NODE_ENV === 'development') {
      isClickTaleEnabled = _flagsInstanceProperty(_featureFlags).get().devEnableClickTale;
    } else {
      isClickTaleEnabled = !_flagsInstanceProperty(_featureFlags).get().disableClickTale;
    }

    if (isClickTaleEnabled) {
      // Will be dead code removed if not enabled
      var clickTalePartition = process.env.APP_CLICKTALE_PARTITION;
      var clickTaleProjectId = process.env.APP_CLICKTALE_PROJECT_ID;

      if (clickTalePartition !== undefined && clickTaleProjectId !== undefined) {
        var _require = require('./telemetry/initClickTale'),
            initClickTale = _require.initClickTale;

        initClickTale((0, _parseInt2.default)(clickTalePartition, 10), clickTaleProjectId);
      }
    }
  }

  return _promise.default.all(bootRequirements).then(function (bootRequirementResults) {
    return (0, _reduce.default)(bootRequirementResults).call(bootRequirementResults, function (canBoot, bootRequirementResult) {
      if (!canBoot || !bootRequirementResult) {
        return false;
      }

      return true;
    }, true);
  });
};

exports.bootstrap = bootstrap;